module.exports = __webpack_public_path__ + "img/icon_cursor-down.934046ac.svg";